import {STAGE_LOCATION_TYPE} from "./Constants";
export const OVERFLOW_FILTER_TAG_LABEL = "With Overflow";

/**
 * If stageLocationType filter is set, it filter out routes which does not have overflow stage location.
 *
 * @param filterState
 * @param route
 * @return {boolean}
 */
export const applyGlobalStageLocationTypeFilter = (filterState, route) => {
    if (filterState.stageLocationType.length === 0) {
        return true;
    }
    let result = false;
    route.stagingLocations.forEach(location => {
        if (location.type === STAGE_LOCATION_TYPE.OVERFLOW) {
            result = true;
        }
    })
    return result;
}

/**
 * If inline column filter value is provided,
 * This method checks if route has any staging location with display label containing input value.
 * @param route
 * @param value
 * @return {boolean}
 */
export const applyInlineStagingLocationFilter = (route, value) => {
    if (value.length === 0) {
        return true;
    }
    let result = false;
    route.stagingLocations.forEach(location => {
        if (location.displayLabel.toLowerCase().includes(value.toLowerCase())) {
            result = true;
        }
    })
    return result;
}

/**
 * Return filter tag label on the basis of type and value of filter.
 *
 * @param filter
 * @param value
 * @return {string|*}
 */
export const getFilterTagLabel = (filter, value) => {
    if (filter === "stageLocationType") {
        return OVERFLOW_FILTER_TAG_LABEL;
    }
    return value
}


// WEBPACK FOOTER //
// ./src/components/util/FilterUtil.js